import { render, staticRenderFns } from "./SBtn.vue?vue&type=template&id=6ea8817f"
import script from "./SBtn.vue?vue&type=script&lang=js"
export * from "./SBtn.vue?vue&type=script&lang=js"
import style0 from "./SBtn.vue?vue&type=style&index=0&id=6ea8817f&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports